/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Access_TitleInputs */

const en_no_access_title = /** @type {(inputs: No_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No access yet`)
};

const pt_br2_no_access_title = /** @type {(inputs: No_Access_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem acesso ainda`)
};

/**
* | output |
* | --- |
* | "No access yet" |
*
* @param {No_Access_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const no_access_title = /** @type {((inputs?: No_Access_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Access_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_access_title(inputs)
	return pt_br2_no_access_title(inputs)
});